import { useScrollProgress } from '@/hooks/useInView'

/**
 * Reading-progress bar under the header. Decorative, so it is hidden from
 * assistive technology — the same information is available from the scrollbar.
 */
export function ScrollProgress() {
  const progress = useScrollProgress()

  return (
    <div aria-hidden="true" className="absolute inset-x-0 bottom-0 h-[2px] overflow-hidden">
      <span
        className="block h-full origin-left bg-gradient-to-r from-primary via-violet to-projected transition-transform duration-150 ease-out"
        style={{ transform: `scaleX(${progress})` }}
      />
    </div>
  )
}
